const normalizeParticipantForComparison = (participant) => ({
  fachkraftId: participant?.fachkraftId != null ? Number(participant.fachkraftId) : null,
  firstName: (participant?.firstName || '').trim(),
  lastName: (participant?.lastName || '').trim(),
  eMail: (participant?.eMail || '').trim().toLowerCase(),
});

const getParticipantComparisonKey = (participant) =>
  [
    participant.fachkraftId ?? 'guest',
    participant.firstName,
    participant.lastName,
    participant.eMail,
  ].join('|');

const normalizeParticipantsForComparison = (participants = []) =>
  participants
    .map(normalizeParticipantForComparison)
    .sort((participantA, participantB) =>
      getParticipantComparisonKey(participantA).localeCompare(getParticipantComparisonKey(participantB))
    );

const haveSameParticipants = (formParticipants = [], registeredParticipants = []) => {
  const normalizedFormParticipants = normalizeParticipantsForComparison(formParticipants);
  const normalizedRegisteredParticipants = normalizeParticipantsForComparison(registeredParticipants);

  if (normalizedFormParticipants.length !== normalizedRegisteredParticipants.length) {
    return false;
  }

  return normalizedFormParticipants.every((participant, index) => {
    const registeredParticipant = normalizedRegisteredParticipants[index];
    return (
      participant.fachkraftId === registeredParticipant.fachkraftId &&
      participant.firstName === registeredParticipant.firstName &&
      participant.lastName === registeredParticipant.lastName &&
      participant.eMail === registeredParticipant.eMail
    );
  });
};

export const isRegisteredParticipantState = (formParticipants = [], registeredParticipants = []) =>
  registeredParticipants.length > 0 &&
  formParticipants.length > 0 &&
  haveSameParticipants(formParticipants, registeredParticipants);
